/**
 * @module geo
 */
import {Store} from 'redux';
import watch from 'redux-watch';

import {Application} from './application';
import {AppStore} from './store/app';
import {stateOfApp} from './store/selectors';

/** 
 * @private
 * @hidden
 */
export function ProviderApp(store: Store<AppStore>, application: Application) {
  const w = watch(() => stateOfApp(store.getState()));
  store.subscribe(w((newVal: number, oldVal: number) => {
    if (newVal === 3) {
      application.skeletonBuild(store.getState(), store);
    }
  }));
}
